const MainScoreGauge = ({ score, title, band }) => {
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  const color = score > 80 ? "#22c55e" : score > 50 ? "#f59e0b" : "#ef4444";
  // Prefer the backend-computed band label; fall back to the legacy heuristic
  // for older audits that predate the band field.
  const statusText = band || (score > 80 ? "Excellent" : score > 50 ? "Good" : "Needs Work");
  return (
    <div className="flex flex-col items-center justify-center p-6 bg-surface-container-lowest rounded-xl h-full">
      <div className="relative w-[140px] h-[140px]">
        <svg width="140" height="140" className="transform -rotate-90">
          <circle
            className="text-surface-container-high"
            strokeWidth="10"
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx="70"
            cy="70"
          />
          <circle
            className="transition-all duration-700 ease-out"
            strokeWidth="10"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            stroke={color}
            fill="transparent"
            r={radius}
            cx="70"
            cy="70"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-4xl font-bold text-on-surface">{score}</span>
          <span className="text-xs font-medium text-on-surface-variant mt-1">{statusText}</span>
        </div>
      </div>
      <p className="mt-4 text-center text-sm font-semibold text-on-surface">{title}</p>
    </div>
  );
};

export default MainScoreGauge;
